import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const NavigationBar = () => {

    const [language, setLanguage] = useState('GR');
    const navigate = useNavigate();

    const changeLanguage = () => {
        let newLanguage;
        if (language === "GR") {
            newLanguage = "EN"
        } else {
            newLanguage = "GR"
        }
        setLanguage(newLanguage);

        const currentUrl = window.location.pathname;
        const newUrl = newLanguage === "EN"
            ? `en${currentUrl}`  // Add '/en' if switching to English
            : currentUrl.replace(/^\/en/, '');
        navigate(newUrl);
    }

    return (
        <div className="navigation-bar">
            <div className='navigation-bar-content'>
                <div className='navigation-bar-brand'>
                    <p>LAMPROS TATSAKIS</p>
                </div>
                <div className='navigation-bar-options'>
                    <NavLink
                        to={language === "EN" ? "/en/" : "/"}
                        end
                        className={({ isActive }) =>
                            "navigation-bar-option" + (isActive ? " active" : "")
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <p>Gallery</p>
                                {isActive && <div className='navigation-bar-option-selected'></div>}
                            </>
                        )}
                    </NavLink>

                    <NavLink
                        to={language === "EN" ? "/en/about" : "/about"}
                        end
                        className={({ isActive }) =>
                            "navigation-bar-option" + (isActive ? " active" : "")
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <p>About</p>
                                {isActive && <div className='navigation-bar-option-selected'></div>}
                            </>
                        )}
                    </NavLink>
                </div>
                <div className='language-selectors'>
                    <p onClick={changeLanguage}>{language}</p>
                </div>
            </div>

        </div>
    );
};

export default NavigationBar;